import { useEffect, useState } from 'react';
import LocalizationManager from './LocalizationManager';

const useLocalization = () => {
  const i18n = LocalizationManager.i18n;

  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

  useEffect(() => {
    const handleLanguageChange = (lng: string) => setCurrentLanguage(lng);

    i18n.on('languageChanged', handleLanguageChange);

    return () => i18n.off('languageChanged', handleLanguageChange);
  }, [i18n]);

  const changeLanguage = LocalizationManager.changeLanguage;

  const t = LocalizationManager.t;

  return { currentLanguage, changeLanguage, t };
};

export default useLocalization;
